<template>
  <bootstrap-modal
    size="lg"
    @modal-close="$emit('modal-close')"
  >
    <div
      slot="header"
      class="modal-header"
    >
      <button
        type="button"
        class="close modal__close-button letter-jacket-option-modal__close-button"
        data-dismiss="modal"
        aria-label="Close"
        @click="$emit('modal-close')"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4
        class="modal-title letter-jacket-option-modal__title"
      >
        Select {{ productRetailName }}
      </h4>
    </div>
    <div
      slot="body"
      class="modal-body letter-jacket-option-modal__body"
    >
      <div class="row">
        <div
          v-for="option in options"
          :key="option.Id"
          class="col-xs-6 col-sm-4 col-lg-2"
          @click="handleOptionClick(option)"
        >
          <div class="letter-jacket-option-modal__option">
            <img
              :src="option.Image.File.Url"
              class="letter-jacket-option-modal__option-image"
            >
            <div class="text-center letter-jacket-option-modal__option-name">
              {{ optionName(option) }}
            </div>
            <div>
              <button
                type="button"
                class="button letter-jacket-option-modal__option-btn"
              >Select</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="modal-footer letter-jacket-option-modal__footer"
    />
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@Shared/components/BootstrapModal.vue'
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'LetterJacketOptionModal',
  components: {
    BootstrapModal
  },
  props: {
    productRetailName: { type: String, default: null, required: true },
    options: { type: Array, default: function () { return [] }, required: true }
  },
  methods: {
    handleOptionClick (option) {
      GoogleAnalytics.trackEvent(
        'Option Product Modal Select',
        'click',
        option.Name
      )

      this.$emit('option-selected', option)
    },
    optionName (option) {
      if (option.RetailName !== null) {
        return option.RetailName
      }

      return option.Name
    }
  }
}
</script>

<style lang="scss" scoped>
.letter-jacket-option-modal {
  &__close-button {
    margin-top: 12px;
  }

  &__title {
    font-size: 36px;
    font-weight: 600;
    line-height: 40px;
  }

  &__body {
    padding: 40px 40px 20px 40px;
    max-height: 600px; // allows two rows of options to show before scrollbars appear
    overflow-x: hidden;
    overflow-y: auto;
  }

  &__option {
    margin-bottom: 20px;
    cursor: pointer;

    &-image {
      border: 1px solid #757575;
      display: block;
      height: 125px;
      margin: 0 auto 10px auto;
      width: 125px;
    }

    &-name {
      font-size: 16px;
      height: 34px;
      line-height: 20px;
      margin-bottom: 10px;
    }

    &-btn {
      background-color: #fff;
      border: 2px solid $letterjacket-color-blue;
      color: $letterjacket-color-blue;
      font-size: 14px;
      font-weight: normal;
      height: auto;
      line-height: 18px;
      margin: 0;
      padding: 4px 0;
      text-align: center;
      width: 100%;

      &:hover {
        background-color: $letterjacket-color-blue;
        color: #fff;
      }
    }
  }

  &__footer {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/LetterJacketOptionModal.vue